export { DMS_MODULE } from '../constants';
export const NAME = 'VerificationHistory';
export const CRUMB_LABEL_KEY = 'VerificationHistory';
export const VERIFICATION_HISTORY_PARTS = 'VerificationHistoryParts';

export const DEPENDENT_TABLES = <const>[
	VERIFICATION_HISTORY_PARTS,
];

export type DependentTableNames = typeof DEPENDENT_TABLES[number];
